import { Button, Typography, IconButton, InputAdornment } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useStyles from "./styles";
import SRE_Logo from "../../../assets/logo.png";
import arrowBack from "../../../assets/backArrow.png";
import questionmark from "../../../assets/questionMarkS.png";
import { Link } from "react-router-dom";
type Props = {};
const IDVerificationRequiered = (props: Props) => {
  // const { width, height } = useWindowDimensions();
  const styles = useStyles();
  const navigate = useNavigate();
  // const loading = useSelector(selectLoading);
  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState(false);
  const [keyDown, setKeyDown] = useState(false);
  const onKeyDown = (e) => {
    setKeyDown(true);
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAmount(event.target.value);
    // dispatch(actions.setForm({ key: `loginForm.${name}`, value }));
  };

  const goBack = () => {
    navigate(-1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let tempAmount = parseInt(amount);
    if (
      tempAmount === undefined ||
      tempAmount === null ||
      tempAmount === 0 ||
      tempAmount < 250
    ) {
      setAmountError(true);
      setTimeout(() => {
        setAmountError(false);
      }, 5000);
    } else {
      navigate("/id-verification-pending");
    }
  };

  const checkBox = () => {};
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        background: "#FFF7DD",
      }}
    >
      <div className={styles.upperContainer}>
        <IconButton
          sx={{ width: "24px", height: "24px", margin: "20px 0 0px 20px" }}
          onClick={goBack}
        >
          <img
            src={arrowBack}
            style={{
              height: 16,
              width: 16,
            }}
            alt="<-"
          />
        </IconButton>
        <div className={styles.logoContainer}>
          <img src={SRE_Logo} alt="logo" className={styles.logo} />
        </div>
      </div>
      <div className={styles.lowerContainer}>
        <Typography className={styles.pageHeading}>My Property</Typography>
        <div className={styles.centerContainer}>
          <Typography className={styles.pageTypo0}>
            ID Verification is required!
          </Typography>
        </div>
        <Button
          className={styles.signInButton}
          variant="contained"
          onClick={handleSubmit}
        >
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontStyle: "normal",
              fontWeight: 700,
              fontSize: "14px",
              letterSpacing: "0.2px",
            }}
          >
            Start ID Verification
          </Typography>
        </Button>
        <Typography className={styles.bottomTypo}>
          Do you need help?
          <br />
          Contact us at{" "}
          <Link className={styles.bottomLink} to="/welcomScreen">
            Support@Sre-Management.com
          </Link>
        </Typography>
      </div>
    </div>
  );
};

export default IDVerificationRequiered;
